
















































































import { defineComponent, PropType } from "@vue/composition-api";
import { checkColorOption, checkSizeOption } from "~/modules/checkout/helpers";
import { getBgColorByVariants } from "~/modules/catalog/category/helpers";
import { MapProductVariant } from "~/modules/catalog/category/composables/useElasticSearch/types";

export default defineComponent({
  name: "EditItemCartAvaiableOptions",
  props: {
    availableOptions: {
      type: Object as PropType<{ size: any[]; color: any[] }>,
      default: null,
    },
    selectedOption: {
      type: Object as PropType<{ size: any; color: any }>,
      required: true,
    },
    dataCheckOptionInstock: {
      type: Array as PropType<any[]>,
      required: true,
    },
    parentSku: {
      type: String as PropType<string>,
      default: "",
    },
    showColorAlert: {
      type: Boolean,
      default: false,
    },
    showSizeAlert: {
      type: Boolean,
      default: false,
    },
    variants: {
      type: Array as PropType<MapProductVariant[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const handleChangeOption = (option) => {
      // if (option.type === "color" && !isColorAvailable(option)) return;
      if (option.type === "size" && !isCheckDisableSize(option.label)) {
        return;
      }
      emit("update:selectedOption", option);
    };

    const isOptionSelected = (attributeOption) => {
      return (
        props.selectedOption[attributeOption.type] &&
        props.selectedOption[attributeOption.type].uid === attributeOption.uid
      );
    };

    const isColorAvailable = (colorOption) => {
      if (!props.availableOptions.size) {
        return true;
      }

      if (
        !props.dataCheckOptionInstock ||
        Object.keys(props.dataCheckOptionInstock).length === 0
      ) {
        return true;
      }

      const colorLabel = colorOption.label;

      for (const sizeOption of props.availableOptions.size) {
        const sizeLabel = sizeOption.label;
        const sku = `${props.parentSku}-${colorLabel}-${sizeLabel}`;

        for (const key in props.dataCheckOptionInstock) {
          if (
            props.dataCheckOptionInstock[key].sku === sku &&
            props.dataCheckOptionInstock[key].is_in_stock
          ) {
            return true;
          }
        }
      }

      return false;
    };

    const isCheckDisableSize = (size: string) => {
      if (props.dataCheckOptionInstock?.length > 0) {
        let sku =
          props.parentSku +
          (props.selectedOption?.color?.label
            ? "-" + props.selectedOption.color.label
            : "") +
          "-" +
          size;

        let stock = props.dataCheckOptionInstock.find((e) => e.sku === sku);

        if (stock) {
          return stock?.is_in_stock;
        }
      }
      return true;
    };

    const sortSizeOptionsByKey = (data) => {
      let options = data;
      let key = "label";
      let defaultSizeText = [
        "XXXS",
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL",
      ];
      let sizeText = [];
      let sizeNumber = [];

      defaultSizeText?.forEach((label, i) => {
        options?.forEach((value, j) => {
          if (label === value[key]) {
            sizeText.push(value);
          }
        });
      });
      options?.forEach((value, i) => {
        let existInDefaultSizeText = false;
        defaultSizeText?.forEach((label, j) => {
          if (value[key] === label) {
            existInDefaultSizeText = true;
          }
        });
        if (!existInDefaultSizeText) {
          sizeNumber.push(value);
        }
      });
      sizeNumber.sort((a, b) => a[key] - b[key]);
      return [...sizeNumber, ...sizeText];
    };

    const openSizeGuide = () => {
      emit("openSizeGuide");
    };

  const checkSizeByVariants = (sizeOption, colorOption) => {
      if (props.availableOptions.color.length > 0 && !colorOption) return false;
      if (!props.variants || !props.variants.length) return false;
      if (props.availableOptions.color.length == 0){
        return true;
      }

      const hasMatchingSize = props.variants.some((variant) => 
        variant?.size == sizeOption?.value_index && variant?.color == colorOption?.value_index)
      return hasMatchingSize;
    };

    return {
      isOptionSelected,
      getBgColorByVariants,
      handleChangeOption,
      isCheckDisableSize,
      sortSizeOptionsByKey,
      openSizeGuide,
      checkSizeByVariants,
      isColorAvailable,
      checkColorOption,
      checkSizeOption,
    };
  },
});
